var map = {
	"./de.json": 859687,
	"./en.json": 223244,
	"./es.json": 858433,
	"./fr.json": 557327,
	"./it.json": 591363,
	"./ja.json": 819331,
	"./ko.json": 109406,
	"./pl.json": 27203,
	"./pt.json": 255210,
	"./ru.json": 626607,
	"./uk.json": 765903
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 385119;